import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type LaunchPromoStatus = {
  active: boolean;
  max_chefs: number;
  taken: number;
  remaining: number;
  duration_days: number;
};

export const LAUNCH_PROMO_KEY = ["launch-promo-status"] as const;

export function useLaunchPromo() {
  return useQuery<LaunchPromoStatus>({
    queryKey: LAUNCH_PROMO_KEY,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("launch_promo_status");
      if (error) throw error;
      const row = Array.isArray(data) ? data[0] : data;
      return (row as LaunchPromoStatus) ?? {
        active: true, max_chefs: 100, taken: 0, remaining: 100, duration_days: 90,
      };
    },
    staleTime: 30_000,
  });
}